<template>
  <div>
    <WuMaoBill v-if="isWuMaoAccount" />
    <ChengKuangBill v-else />
  </div>
</template>

<script>
  import ChengKuangBill from './salesLadingbill/list.vue';
  import WuMaoBill from './materialSalesLadingbill/list.vue';
  export default {
    name: 'salesLadingbill',
    components: { ChengKuangBill, WuMaoBill },
  };
</script>

<style lang="scss" scoped></style>
